import React, { PropsWithChildren } from 'react';
import * as S from './Dropdown.styles';
import { DropdownProps } from './Dropdown.types';

export const Dropdown = ({
  isOpen,
  alignment = 'right',
  hasOverlay = true,
  onClose,
  className,
  children,
}: PropsWithChildren<DropdownProps>) => {
  return (
    <>
      {hasOverlay && (
        <S.DropdownOverlay
          isOpen={isOpen}
          data-testid="dropdown-overlay"
          onClick={onClose}
        />
      )}
      {isOpen && (
        <S.DropdownMenu
          className={className}
          $alignment={alignment}
          data-testid="dropdown-menu"
        >
          {children}
        </S.DropdownMenu>
      )}
    </>
  );
};
